module.exports = __webpack_public_path__ + "fonts/VetoSansCond-LightItalic_1.4c0043d6.woff";